import type { CampaignParamKey } from './campaign'

export type ServiceProductModel = {
  cache_key: number,
  categories?: number[],
  compatible_publications?: number[],
  id: number,
  options: {
    attachable: {
      required: boolean,
      string: string,
    },
    digital: {
      custom_domain: boolean,
      templatable: boolean,
      type: string,
    },
    locked: boolean,
    proposal: {
      templatable: boolean,
      type: string,
    },
    publication?: {
      grid: {
        columns: number,
        rows: number,
      },
    },
    required_campaign_fields: CampaignParamKey[],
    skip_quotes: boolean,
    social_media: {
      buildable: boolean,
      templatable: boolean,
    },
    artwork: {
      imposable: boolean,
    },
  },
  orderable: boolean,
  reference_title?: string,
  service_id: number,
  title: string,
}

export type ServiceProductModelRequestOptions = {
  include_publication_provider: boolean,
  include_service_product_assigned_publications: boolean,
  include_service_product_editorial_publications: boolean,
  include_service_product_compatible_products: boolean,
}

const state = {
  id: null,
  locked: false,
  options: {
    attachable: {
      required: false,
      string: '',
    },
    digital: {
      custom_domain: false,
      templatable: false,
      type: '',
    },
    locked: false,
    proposal: {
      templatable: false,
      type: '',
    },
    skip_quotes: false,
    social_media: {
      buildable: false,
      templatable: false,
    },
  },
  orderable: true,
  reference_title: '',
  service_id: undefined,
  title: '',
}

export const requiredFields = [
  { key: 'service_id' },
  { key: 'title' },
]

export default state
